// extracted by mini-css-extract-plugin
export var fileUpload = "_dz-1";
export var modalButton = "_dz-0";